import { render, staticRenderFns } from "./_DropzoneUpload.vue?vue&type=template&id=2b61d45e"
import script from "./_DropzoneUpload.vue?vue&type=script&lang=js"
export * from "./_DropzoneUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports